module.exports = __webpack_public_path__ + "static/media/1POLICY4.b7cb5d53.jpg";